import { render, staticRenderFns } from "./ComInput.vue?vue&type=template&id=b8af9760&scoped=true&"
import script from "./ComInput.vue?vue&type=script&lang=js&"
export * from "./ComInput.vue?vue&type=script&lang=js&"
import style0 from "./ComInput.vue?vue&type=style&index=0&id=b8af9760&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8af9760",
  null
  
)

export default component.exports